import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-dashboard-event',
    templateUrl: './dashboard-event.component.html',
    styleUrls: ['./dashboard-event.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardEventComponent {

}
